<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <h1>{{'プロジェクト情報：編集' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button mat-raised-button color="primary" (click)="editProject()" [disabled]="!projectFormGroup.valid">
          <mat-icon>add</mat-icon>
          <span>{{'更新' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>
  
  <div mat-dialog-content>
    <form class="form" [formGroup]="projectFormGroup">
      <div class="dialog-body" fxLayout="row" fxLayoutGap="24px">

        <div fxLayout="column" fxLayoutGap="20px" fxFlex="100%">
          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">ID</mat-label>
            <input matInput placeholder="ID" id="projectId" formControlName="projectId" readonly>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
            <input matInput placeholder="{{'名称' | translate}}" id="projectName" formControlName="projectName" readonly>
          </mat-form-field>

          <mat-form-field fxFlex="100%">
            <mat-label floatLabel="always">{{'アプリ表示名' | translate}}</mat-label>
            <input matInput placeholder="{{'アプリ表示名' | translate}}" id="projectAppNames" value="{{ project!.project_app_names! | multiName:projectLanguages:projectBaseLang }}" readonly>
            <button matSuffix mat-stroked-button color="primary" (click)="openAppNamesDialog()">
              <mat-icon>edit</mat-icon>
            </button>
          </mat-form-field>

          <div class="categorytitle">{{'▼所在情報' | translate}}</div>
          <div class="categorydesc">{{'*施設や展示などの初期登録時の所在情報になります。' | translate}}</div>
          <google-map
            *ngIf="center"
            height="400px"
            width="100%"
            step="0.00000001"
            [center]="center"
            [zoom]="zoom"
            [options]="options">
            <map-marker #markerElem *ngIf="currentPosition" step="0.00000001" [position]="currentPosition"
              [options]="currentPositionMarkerOption" (mapDragend)="onMerkerDragEnd($event)">
            </map-marker>
          </google-map>
          <input #mapSearchField class="map-search-field" type="text"
            (keydown)="onKeyDownFromSearchPlace($event.keyCode)" />
          <button #mapSearchFieldExecute (click)="searchMap()">{{'移動' | translate}}</button>
          <button #mapSearchFieldClear (click)="clearMapSearchField()">{{'クリア' | translate}}</button>

          <div class="project-area" fxLayout="row" fxLayoutGap="20px">
            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'緯度' | translate}}</mat-label>
              <input matInput placeholder="{{'緯度' | translate}}" id="projectLat" formControlName="projectLat"
                type="number" step="0.00000001" (change)="onBlurMarkerLat()">
              <mat-error *ngIf="projectLatControl.invalid">{{ getErrorMessageToProjectLat() }}</mat-error>
            </mat-form-field>

            <mat-form-field fxFlex="50%">
              <mat-label floatLabel="always">{{'経度' | translate}}</mat-label>
              <input matInput placeholder="{{'経度' | translate}}" id="projectLng" formControlName="projectLng"
                type="number" step="0.00000001" (change)="onBlurMarkerLng()">
              <mat-error *ngIf="projectLngControl.invalid">{{ getErrorMessageToProjectLng() }}</mat-error>
            </mat-form-field>
          </div>

        </div>

      </div>

    </form>
  </div>

</div>